import {Component, EventEmitter, Input, Output} from '@angular/core';
import fa from "@mobiscroll/angular/dist/js/i18n/fa";

@Component({
  selector: 'app-modal-header',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ModalHeaderComponent {
  @Output() clickButton: EventEmitter<void> = new EventEmitter();
  @Input() paddingBottom = '15';
  @Input() loading = false;

  constructor() {
  }

  closeModal() {
    this.clickButton.emit();
  }
}
